import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useProviderService from '@hooks/useProviderService'

const confirmDelete = (deleteProviderService, deleteFn) => {
  const deleteProviderServicePayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Service Removed',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, remove it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Remove Service?',
  }).then(({ value }) => {
    if (value){
      deleteProviderService(deleteProviderServicePayload)
    }
  })
}

const ServiceListItem = (props) => {
  const { providerService } = props

  const pageContext = useContext(PageContext)
  const { callbacks } = pageContext
  const { deleteProviderService } = callbacks || {}

  const {
    callbacks: { createOrEditProviderService, deleteProviderService: deleteFn },
    providerService: {
      deadline,
    },
    service: { title: serviceTitle },
  } = useProviderService(providerService)

  return (
    <DashboardModuleListItem title={serviceTitle}>
      {!!deadline && (
        <DashboardModuleListItem.TertiaryText>
          {deadline}
        </DashboardModuleListItem.TertiaryText>
      )}

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditProviderService()}
          type="edit"
        />

        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(deleteProviderService, deleteFn)}
          type="delete"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

ServiceListItem.propTypes = {
  providerService: PropTypes.object.isRequired,
}

export default ServiceListItem
